import Vue from "./vue_components/Vue.jsx";
import Vue_activated from "./vue_components/Vue_activated.jsx";
import Vue_Animations from "./vue_components/Vue_Animations.jsx";
import Vue_Animations_VFor from "./vue_components/Vue_Animations_VFor.jsx";
import Vue_beforeCreate from "./vue_components/Vue_beforeCreate.jsx";
import Vue_beforeMount from "./vue_components/Vue_beforeMount.jsx";
import Vue_beforeUnmount from "./vue_components/Vue_beforeUnmount.jsx";
import Vue_beforeUpdate from "./vue_components/Vue_beforeUpdate.jsx";
import Vue_Build from "./vue_components/Vue_Build.jsx";
import Vue_BuiltIn_Attributes from "./vue_components/Vue_BuiltIn_Attributes.jsx";
import Vue_BuiltIn_Components from "./vue_components/Vue_BuiltIn_Components.jsx";
import Vue_BuiltIn_Elements from "./vue_components/Vue_BuiltIn_Elements.jsx";
import Vue_Certificate from "./vue_components/Vue_Certificate.jsx";
import Vue_component from "./vue_components/Vue_component.jsx";
import Vue_Components from "./vue_components/Vue_Components.jsx";
import Vue_Component_Instance from "./vue_components/Vue_Component_Instance.jsx";
import Vue_Component_Instance_attrs from "./vue_components/Vue_Component_Instance_attrs.jsx";
import Vue_Component_Instance_data from "./vue_components/Vue_Component_Instance_data.jsx";
import Vue_Component_Instance_el from "./vue_components/Vue_Component_Instance_el.jsx";
import Vue_Component_Instance_emit from "./vue_components/Vue_Component_Instance_emit.jsx";
import Vue_Component_Instance_forceUpdate from "./vue_components/Vue_Component_Instance_forceUpdate.jsx";
import Vue_Component_Instance_nextTick from "./vue_components/Vue_Component_Instance_nextTick.jsx";
import Vue_Component_Instance_parent from "./vue_components/Vue_Component_Instance_parent.jsx";
import Vue_Component_Instance_props from "./vue_components/Vue_Component_Instance_props.jsx";
import Vue_Component_Instance_refs from "./vue_components/Vue_Component_Instance_refs.jsx";
import Vue_Component_Instance_root from "./vue_components/Vue_Component_Instance_root.jsx";
import Vue_Component_Instance_slots from "./vue_components/Vue_Component_Instance_slots.jsx";
import Vue_Component_Instance_watch from "./vue_components/Vue_Component_Instance_watch.jsx";
import Vue_Composition_API from "./vue_components/Vue_Composition_API.jsx";
import Vue_Computed from "./vue_components/Vue_Computed.jsx";
import Vue_created from "./vue_components/Vue_created.jsx";
import Vue_CSS_Binding from "./vue_components/Vue_CSS_Binding.jsx";
import Vue_deactivated from "./vue_components/Vue_deactivated.jsx";
import Vue_Directives from "./vue_components/Vue_Directives.jsx";
import Vue_Dynamic_Components from "./vue_components/Vue_Dynamic_Components.jsx";
import Vue_Emit from "./vue_components/Vue_Emit.jsx";
import Vue_errorCaptured from "./vue_components/Vue_errorCaptured.jsx";
import Vue_Events from "./vue_components/Vue_Events.jsx";
import Vue_Event_Modifiers from "./vue_components/Vue_Event_Modifiers.jsx";
import Vue_Examples from "./vue_components/Vue_Examples.jsx";
import Vue_Exercises from "./vue_components/Vue_Exercises.jsx";
import Vue_Fallthrough from "./vue_components/Vue_Fallthrough.jsx";
import Vue_First_SFC from "./vue_components/Vue_First_SFC.jsx";
import Vue_Forms from "./vue_components/Vue_Forms.jsx";
import Vue_Form_Inputs from "./vue_components/Vue_Form_Inputs.jsx";
import Vue_Home from "./vue_components/Vue_Home.jsx";
import Vue_HTTP_Request from "./vue_components/Vue_HTTP_Request.jsx";
import Vue_Instance_Options from "./vue_components/Vue_Instance_Options.jsx";
import Vue_Instance_Options_computed from "./vue_components/Vue_Instance_Options_computed.jsx";
import Vue_Instance_Options_data from "./vue_components/Vue_Instance_Options_data.jsx";
import Vue_Instance_Options_emits from "./vue_components/Vue_Instance_Options_emits.jsx";
import Vue_Instance_Options_expose from "./vue_components/Vue_Instance_Options_expose.jsx";
import Vue_Instance_Options_methods from "./vue_components/Vue_Instance_Options_methods.jsx";
import Vue_Instance_Options_props from "./vue_components/Vue_Instance_Options_props.jsx";
import Vue_Instance_Options_watch from "./vue_components/Vue_Instance_Options_watch.jsx";
import Vue_Intro from "./vue_components/Vue_Intro.jsx";
import Vue_is_Attribute from "./vue_components/Vue_is_Attribute.jsx";
import Vue_KeepAlive from "./vue_components/Vue_KeepAlive.jsx";
import Vue_key_Attribute from "./vue_components/Vue_key_Attribute.jsx";
import Vue_Lifecycle from "./vue_components/Vue_Lifecycle.jsx";
import Vue_Local_Components from "./vue_components/Vue_Local_Components.jsx";
import Vue_Methods from "./vue_components/Vue_Methods.jsx";
import Vue_mounted from "./vue_components/Vue_mounted.jsx";
import Vue_Props from "./vue_components/Vue_Props.jsx";
import Vue_Provide_Inject from "./vue_components/Vue_Provide_Inject.jsx";
import Vue_Quiz from "./vue_components/Vue_Quiz.jsx";
import Vue_Reference_Lifecycle from "./vue_components/Vue_Reference_Lifecycle.jsx";
import Vue_ref_Attribute from "./vue_components/Vue_ref_Attribute.jsx";
import Vue_renderTracked from "./vue_components/Vue_renderTracked.jsx";
import Vue_renderTriggered from "./vue_components/Vue_renderTriggered.jsx";
import Vue_Routing from "./vue_components/Vue_Routing.jsx";
import Vue_Scoped_Slots from "./vue_components/Vue_Scoped_Slots.jsx";
import Vue_Scoped_Styling from "./vue_components/Vue_Scoped_Styling.jsx";
import Vue_Server from "./vue_components/Vue_Server.jsx";
import Vue_serverPrefetch from "./vue_components/Vue_serverPrefetch.jsx";
import Vue_Setup from "./vue_components/Vue_Setup.jsx";
import Vue_slot from "./vue_components/Vue_slot.jsx";
import Vue_Slots from "./vue_components/Vue_Slots.jsx";
import Vue_Study_Plan from "./vue_components/Vue_Study_Plan.jsx";
import Vue_Syllabus from "./vue_components/Vue_Syllabus.jsx";
import Vue_Teleport from "./vue_components/Vue_Teleport.jsx";
import Vue_template from "./vue_components/Vue_template.jsx";
import Vue_Templates from "./vue_components/Vue_Templates.jsx";
import Vue_Template_Refs from "./vue_components/Vue_Template_Refs.jsx";
import Vue_Transition from "./vue_components/Vue_Transition.jsx";
import Vue_TransitionGroup from "./vue_components/Vue_TransitionGroup.jsx";
import Vue_unmounted from "./vue_components/Vue_unmounted.jsx";
import Vue_updated from "./vue_components/Vue_updated.jsx";
import Vue_VBind from "./vue_components/Vue_VBind.jsx";
import Vue_VFor from "./vue_components/Vue_VFor.jsx";
import Vue_VFor_Components from "./vue_components/Vue_VFor_Components.jsx";
import Vue_VIf from "./vue_components/Vue_VIf.jsx";
import Vue_VModel from "./vue_components/Vue_VModel.jsx";
import Vue_VOn from "./vue_components/Vue_VOn.jsx";
import Vue_VShow from "./vue_components/Vue_VShow.jsx";
import Vue_VSlot from "./vue_components/Vue_VSlot.jsx";
import Vue_v_bind from "./vue_components/Vue_v_bind.jsx";
import Vue_v_cloak from "./vue_components/Vue_v_cloak.jsx";
import Vue_v_else from "./vue_components/Vue_v_else.jsx";
import Vue_v_else_if from "./vue_components/Vue_v_else_if.jsx";
import Vue_v_for from "./vue_components/Vue_v_for.jsx";
import Vue_v_html from "./vue_components/Vue_v_html.jsx";
import Vue_v_if from "./vue_components/Vue_v_if.jsx";
import Vue_v_memo from "./vue_components/Vue_v_memo.jsx";
import Vue_v_model from "./vue_components/Vue_v_model.jsx";
import Vue_v_on from "./vue_components/Vue_v_on.jsx";
import Vue_v_once from "./vue_components/Vue_v_once.jsx";
import Vue_v_pre from "./vue_components/Vue_v_pre.jsx";
import Vue_v_show from "./vue_components/Vue_v_show.jsx";
import Vue_v_slot from "./vue_components/Vue_v_slot.jsx";
import Vue_v_text from "./vue_components/Vue_v_text.jsx";
import Vue_Watchers from "./vue_components/Vue_Watchers.jsx";

const vueComponentsMap = {
  "<Vue />": Vue,
  "<Vue_activated />": Vue_activated,
  "<Vue_Animations />": Vue_Animations,
  "<Vue_Animations_VFor />": Vue_Animations_VFor,
  "<Vue_beforeCreate />": Vue_beforeCreate,
  "<Vue_beforeMount />": Vue_beforeMount,
  "<Vue_beforeUnmount />": Vue_beforeUnmount,
  "<Vue_beforeUpdate />": Vue_beforeUpdate,
  "<Vue_Build />": Vue_Build,
  "<Vue_BuiltIn_Attributes />": Vue_BuiltIn_Attributes,
  "<Vue_BuiltIn_Components />": Vue_BuiltIn_Components,
  "<Vue_BuiltIn_Elements />": Vue_BuiltIn_Elements,
  "<Vue_Certificate />": Vue_Certificate,
  "<Vue_component />": Vue_component,
  "<Vue_Components />": Vue_Components,
  "<Vue_Component_Instance />": Vue_Component_Instance,
  "<Vue_Component_Instance_attrs />": Vue_Component_Instance_attrs,
  "<Vue_Component_Instance_data />": Vue_Component_Instance_data,
  "<Vue_Component_Instance_el />": Vue_Component_Instance_el,
  "<Vue_Component_Instance_emit />": Vue_Component_Instance_emit,
  "<Vue_Component_Instance_forceUpdate />": Vue_Component_Instance_forceUpdate,
  "<Vue_Component_Instance_nextTick />": Vue_Component_Instance_nextTick,
  "<Vue_Component_Instance_parent />": Vue_Component_Instance_parent,
  "<Vue_Component_Instance_props />": Vue_Component_Instance_props,
  "<Vue_Component_Instance_refs />": Vue_Component_Instance_refs,
  "<Vue_Component_Instance_root />": Vue_Component_Instance_root,
  "<Vue_Component_Instance_slots />": Vue_Component_Instance_slots,
  "<Vue_Component_Instance_watch />": Vue_Component_Instance_watch,
  "<Vue_Composition_API />": Vue_Composition_API,
  "<Vue_Computed />": Vue_Computed,
  "<Vue_created />": Vue_created,
  "<Vue_CSS_Binding />": Vue_CSS_Binding,
  "<Vue_deactivated />": Vue_deactivated,
  "<Vue_Directives />": Vue_Directives,
  "<Vue_Dynamic_Components />": Vue_Dynamic_Components,
  "<Vue_Emit />": Vue_Emit,
  "<Vue_errorCaptured />": Vue_errorCaptured,
  "<Vue_Events />": Vue_Events,
  "<Vue_Event_Modifiers />": Vue_Event_Modifiers,
  "<Vue_Examples />": Vue_Examples,
  "<Vue_Exercises />": Vue_Exercises,
  "<Vue_Fallthrough />": Vue_Fallthrough,
  "<Vue_First_SFC />": Vue_First_SFC,
  "<Vue_Forms />": Vue_Forms,
  "<Vue_Form_Inputs />": Vue_Form_Inputs,
  "<Vue_Home />": Vue_Home,
  "<Vue_HTTP_Request />": Vue_HTTP_Request,
  "<Vue_Instance_Options />": Vue_Instance_Options,
  "<Vue_Instance_Options_computed />": Vue_Instance_Options_computed,
  "<Vue_Instance_Options_data />": Vue_Instance_Options_data,
  "<Vue_Instance_Options_emits />": Vue_Instance_Options_emits,
  "<Vue_Instance_Options_expose />": Vue_Instance_Options_expose,
  "<Vue_Instance_Options_methods />": Vue_Instance_Options_methods,
  "<Vue_Instance_Options_props />": Vue_Instance_Options_props,
  "<Vue_Instance_Options_watch />": Vue_Instance_Options_watch,
  "<Vue_Intro />": Vue_Intro,
  "<Vue_is_Attribute />": Vue_is_Attribute,
  "<Vue_KeepAlive />": Vue_KeepAlive,
  "<Vue_key_Attribute />": Vue_key_Attribute,
  "<Vue_Lifecycle />": Vue_Lifecycle,
  "<Vue_Local_Components />": Vue_Local_Components,
  "<Vue_Methods />": Vue_Methods,
  "<Vue_mounted />": Vue_mounted,
  "<Vue_Props />": Vue_Props,
  "<Vue_Provide_Inject />": Vue_Provide_Inject,
  "<Vue_Quiz />": Vue_Quiz,
  "<Vue_Reference_Lifecycle />": Vue_Reference_Lifecycle,
  "<Vue_ref_Attribute />": Vue_ref_Attribute,
  "<Vue_renderTracked />": Vue_renderTracked,
  "<Vue_renderTriggered />": Vue_renderTriggered,
  "<Vue_Routing />": Vue_Routing,
  "<Vue_Scoped_Slots />": Vue_Scoped_Slots,
  "<Vue_Scoped_Styling />": Vue_Scoped_Styling,
  "<Vue_Server />": Vue_Server,
  "<Vue_serverPrefetch />": Vue_serverPrefetch,
  "<Vue_Setup />": Vue_Setup,
  "<Vue_slot />": Vue_slot,
  "<Vue_Slots />": Vue_Slots,
  "<Vue_Study_Plan />": Vue_Study_Plan,
  "<Vue_Syllabus />": Vue_Syllabus,
  "<Vue_Teleport />": Vue_Teleport,
  "<Vue_template />": Vue_template,
  "<Vue_Templates />": Vue_Templates,
  "<Vue_Template_Refs />": Vue_Template_Refs,
  "<Vue_Transition />": Vue_Transition,
  "<Vue_TransitionGroup />": Vue_TransitionGroup,
  "<Vue_unmounted />": Vue_unmounted,
  "<Vue_updated />": Vue_updated,
  "<Vue_VBind />": Vue_VBind,
  "<Vue_VFor />": Vue_VFor,
  "<Vue_VFor_Components />": Vue_VFor_Components,
  "<Vue_VIf />": Vue_VIf,
  "<Vue_VModel />": Vue_VModel,
  "<Vue_VOn />": Vue_VOn,
  "<Vue_VShow />": Vue_VShow,
  "<Vue_VSlot />": Vue_VSlot,
  "<Vue_v_bind />": Vue_v_bind,
  "<Vue_v_cloak />": Vue_v_cloak,
  "<Vue_v_else />": Vue_v_else,
  "<Vue_v_else_if />": Vue_v_else_if,
  "<Vue_v_for />": Vue_v_for,
  "<Vue_v_html />": Vue_v_html,
  "<Vue_v_if />": Vue_v_if,
  "<Vue_v_memo />": Vue_v_memo,
  "<Vue_v_model />": Vue_v_model,
  "<Vue_v_on />": Vue_v_on,
  "<Vue_v_once />": Vue_v_once,
  "<Vue_v_pre />": Vue_v_pre,
  "<Vue_v_show />": Vue_v_show,
  "<Vue_v_slot />": Vue_v_slot,
  "<Vue_v_text />": Vue_v_text,
  "<Vue_Watchers />": Vue_Watchers,
};

export default vueComponentsMap;
